<template>
  <div class="wrap">
    <p class="pageTitle">添加功能集</p>
    <div class="form">
      <el-form
        :model="form"
        :inline="true"
        :rules="rules"
        label-position="right"
        ref="form"
        label-width="150px"
      >
        <el-form-item class="mr20" label="功能集名称：" prop="name">
          <el-input placeholder="15字以内" class="w300" maxlength="15" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item class="ml20" label="是否纳入食安指数分析：" label-width="400" prop="enableIndex">
          <el-select v-model="form.enableIndex" placeholder="请选择">
            <el-option label="是" :value=1></el-option>
            <el-option label="否" :value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="功能集描述" prop="remarks">
          <el-input type="textarea" placeholder="请输入对功能集的描述，如，“适用于只有一个食堂的学校”,50字内" maxlength="50" class="w300" :rows="3" v-model="form.remarks"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="box">
      <toggle-form title="功能模块">
        <div class="singleBox">
          <p class="moduleTitle">通用功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in moduleData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange(item.moduleString)"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
          <p class="moduleTitle">PC网页端功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in pcData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
                 @change="switchChange(item.moduleString)"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
          <p class="moduleTitle">一店一码功能模块</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in oneStoreModuleData" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="item.defaultState"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
      <toggle-form title="公示模块">
        <div class="singleBox">
          <ul class="clear_a">
            <li
              class="clear_a"
              v-if="publicData[item].show === true"
              v-for="(item,index) in Object.keys(publicData)"
              :key="index"
            >
              <p class="moduleName">{{publicData[item].moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="publicData[item].defaultState"
                :disabled="publicData[item].frozen === 1"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{publicData[item].defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
      <toggle-form title="预警模块">
        <div class="singleBox" v-for="(items, i) in Object.keys(warningData)" :key="i">
          <p class="moduleTitle">{{warningName[items]}}</p>
          <ul class="clear_a">
            <li class="clear_a" v-for="(item,index) in warningData[items]" :key="index">
              <p class="moduleName">{{item.moduleName}}</p>
              <el-switch
                class="mt2 fr"
                v-model="item.defaultState"
                :disabled="item.frozen === 1"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <p class="switch mr10 fr">{{item.defaultState === 0?'禁用':'启用'}}</p>
            </li>
          </ul>
        </div>
      </toggle-form>
    </div>
    <div class="fr">
      <el-button type="primary" class="mt20" @click="addConfirm('form')">确认</el-button>
    </div>
  </div>
</template>
<script>
import ToggleForm from "components/ToggleForm"
import * as api from "api/module";
export default {
  components: {
    ToggleForm
  },
  data() {
    return {
      form: {
        name: '',
        enableIndex: 0,
        remarks: ''
      },
      value2: 1,
      warningData: {
        after_cooking_management_abnormal: [],
        ai_camera_abnormal: [],
        source_trace_abnormal: [],
        pesticide_detection_abnormal: [],
        general_abnormal: [],
        supervision_inspection_abnormal: [],
      },
      warningName: {
        after_cooking_management_abnormal: '后厨管理异常',
        ai_camera_abnormal: 'AI摄像头',
        source_trace_abnormal: '溯源异常',
        pesticide_detection_abnormal: '检测异常',
        general_abnormal: '一般异常',
        supervision_inspection_abnormal: '监督检查异常',
      },
      moduleData: [],
      oneStoreModuleData: [],
      pcData: [],
      publicity: [],
      publicData: {},
      rules: {
        name: [
          { required: true, message: '请输入功能集名称', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' }
        ],
        enableIndex: [
          { required: true, message: '请选择是否纳入食安指数', trigger: 'change' }
        ],
        remarks: [
          { required: true, message: '请填写功能集描述', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    async getMoudle() {
      const loading = this.$loading();
      let result = await api.getModule();
      result.data.map(item => {
        switch (item.subGroupString) {
          case 'one_store_common_function':
            this.oneStoreModuleData.push(item);
            break;
          case 'common_function':
            this.moduleData.push(item);
            break;
          case 'default':
            this.publicity.push(item);
            break;
          case 'pc_web_function':
            this.pcData.push(item);
            break;
          case 'after_cooking_management_abnormal':
            this.warningData.after_cooking_management_abnormal.push(item);
            break;
          case 'ai_camera_abnormal':
            this.warningData.ai_camera_abnormal.push(item);
            break;
          case 'source_trace_abnormal':
            this.warningData.source_trace_abnormal.push(item);
            break;
          case 'pesticide_detection_abnormal':
            this.warningData.pesticide_detection_abnormal.push(item)
            break;
          case 'general_abnormal':
            this.warningData.general_abnormal.push(item);
            break;
          case 'supervision_inspection_abnormal':
            this.warningData.supervision_inspection_abnormal.push(item);
            break;
        }
      })
      this.publicity.forEach(item => {
        this.publicData[item.moduleString] = item
        this.publicData[item.moduleString].show = true
      })
      loading.close();
    },
    switchChange(module) {
      if (this.publicData[module]) {
        this.publicData[module].show = !this.publicData[module].show
      }
    },
    async addData() {
      const loading = this.$loading();
      let functionCollection = []
      let publicCollection = []
      let warningCollection = []
      this.moduleData.forEach(item => { item.defaultState === 1 ? functionCollection.push(item.id) : '' })
      this.pcData.forEach(item => { item.defaultState === 1 ? functionCollection.push(item.id) : '' })
      Object.keys(this.publicData).forEach(item => { this.publicData[item].show === true && this.publicData[item].defaultState === 1 ? publicCollection.push(this.publicData[item].id) : '' })
      Object.keys(this.warningData).forEach(item => { this.warningData[item].forEach(items => { items.defaultState === 1 ? warningCollection.push(items.id) : '' }) })
      this.oneStoreModuleData.forEach(items => { items.defaultState === 1 ? publicCollection.push(items.id) : '' })
      let result = await api.postModuleData({
        "name": this.form.name,
        "remarks": this.form.remarks,
        "enableIndex": this.form.enableIndex,
        "functionCollection": functionCollection.join(','),
        "publicCollection": publicCollection.join(','),
        "warningCollection": warningCollection.join(','),
        "id": ''
      })
      loading.close();
      if (result.code === 200) {
        this.$message({
          message: '添加成功, 正在返回列表页...',
          type: 'success'
        });
        setTimeout(() => {
          this.$router.push('/moduleList')
        }, 1000)
      }
    },
    addConfirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addData()
        } else {
          this.$message({
            message: '请填写完必填信息',
            type: 'warning'
          });
          return false;
        }
      });
    }
  },
  mounted() {
    this.getMoudle()
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  text-align: left;
  .pageTitle {
    font-size: 20px;
    font-family: AlibabaPuHuiTiR;
    color: #333333;
    line-height: 20px;
    margin-bottom: 40px;
  }
  .form {
    margin: 20px auto;
    width: 1000px;
  }
  .box {
    margin: 20px auto 100px auto;
    width: 1000px;
    .singleBox {
      padding: 0 30px;
      box-sizing: border-box;
      > ul > li {
        width: 300px;
        height: 60px;
        background: rgba(244, 244, 244, 1);
        border-radius: 4px;
        padding: 18px 30px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-right: 20px;
        .moduleName {
          font-size: 16px;
          font-family: AlibabaPuHuiTiR;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
        }
        .mt2 {
          margin-top: 2px;
        }
        .switch {
          font-size: 14px;
          font-family: AlibabaPuHuiTiR;
          color: rgba(102, 102, 102, 1);
          line-height: 24px;
        }
      }
      > ul > li:nth-child(3n) {
        margin-right: 0;
      }
    }
    .moduleTitle {
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      margin-top: 20px;
    }
  }
}
</style>
